
if( $('#salvar-na-colecao').length ) {

    var vmColecoes = new Vue({
        el: '#salvar-na-colecao',
        data: {
            id: null,
            tipo: null,
            item: null,
            colecoes: {},
            colecaoSelecionada: -1,
            nomeColecao: null,
            aguardandoAjax: false,
            lightbox: lity()
        },
        methods: {
            temColecoes: function ( ) {
                return objSize(this.colecoes) > 0;
            },
            abrirModal: function (id, tipo) {

                this.id = id;
                this.tipo = tipo;
                this.item = (tipo == 'questao') ? 'Questão' : 'Prova';
                this.colecoes = {};
                this.colecaoSelecionada = -1;
                this.nomeColecao = null;

                this.aguardandoAjax = true;
                this.lightbox('#salvar-na-colecao');

                ajaxGET(
                    '/colecoes/lista-colecoes',
                    { tipo: tipo },
                    this.carregaColecoes
                );
            },
            carregaColecoes: function (dados) {
                this.colecoes = dados;
                this.aguardandoAjax = false;
            },
            salvarNaColecao: function () {

                if (this.colecaoSelecionada == -1) {
                    return -1;
                }

                ajaxPOST(
                    '/colecoes/atualiza-colecao',
                    {
                        id          : this.id,
                        tipo        : this.tipo,
                        colecaoid   : this.colecaoSelecionada
                    }
                );
                this.lightbox.close();
            },
            criarColecao: function () {

                if (!this.nomeColecao) {
                    return -1;
                }

                ajaxPOST(
                    '/colecoes/nova-colecao',
                    {
                        id          : this.id,
                        tipo        : this.tipo,
                        nomecolecao : this.nomeColecao
                    }
                );
                this.lightbox.close();

            }
        }
    });

}